import { useServerVariables } from "contexts/serverVariables";

export default () => {
  const { mode } = useServerVariables();
  return mode === "test";
};
